module.exports = __webpack_public_path__ + "media/02 Adeste Fideles.ca49a123.mp3";